<template>
    <v-dialog max-width="500" v-model="dialog" >
        <v-card >
            <v-card-title class="primary white--text">
              Editar Datos de Pago
              <v-spacer></v-spacer>
              <v-btn icon dark @click="hide" class="mr-1">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text>
              <v-sheet height="300">
                <v-layout wrap>
                  <template v-if="appointment">
                    <v-slide-y-transition>
                      <v-flex xs12  text-center>
                        <attention-payment-form
                            ref="paymentForm"
                            :value="appointment.payment"
                            v-on:update:valid="validPayment = $event"
                        />
                      </v-flex>
                    </v-slide-y-transition>
                  </template>
                </v-layout>
              </v-sheet>
            </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="hide" class="mr-1" depressed>
              Cancelar
            </v-btn>
            <v-btn :loading="loading" :disabled="!validPayment" color="primary" depressed @click="savePayment">Guardar</v-btn>
          </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

    import AttentionPaymentForm from '@/components/payment/AttentionPaymentForm'

    import {ApiUtils} from '@/utils/ApiUtils'
    import {getLabel} from '@/utils/Institution'

    import {mapState, mapMutations, mapGetters} from 'vuex'

    export default{
        components: {
            AttentionPaymentForm
        },
        props: [],
        data(){
            return {
                dialog: false,
                other: false,
                reason: null,
                appointment: null,
                loading: false,
                validPayment: false,
            }
        },
        methods: {
            ...mapMutations(['showSnackBar']),
            getLabel,
            show(appointment){
                this.appointment = appointment
                this.dialog = true
            },
            hide(){
                this.dialog = false
            },
            async savePayment(){

                var vm = this
                if(vm.loading) return

                vm.loading = true
                const response = await ApiUtils.makePost(
                        `payment/${vm.appointment.id}`,
                        vm.$refs.paymentForm.getPaymentData()
                )
                vm.loading = false

                if(response.ok){
                    const json = await response.json()
                    vm.$emit('success', json.result.payment)
                    vm.showSnackBar(`Datos de pago actualizados correctamente`)
                }

            }
        },
        computed: {
          ...mapState(['currentProvider', 'currentUser']),
          ...mapGetters(['specialistSettings']),
            suggestedPrice(){

            }
        },
        watch:{}

    }
</script>
